import {createGlobalStyle} from "styled-components";
// @ts-ignore
import fontsCSS from "./fonts.css"

const FontStyles = createGlobalStyle`
  ${fontsCSS}
`;

export default FontStyles;
